"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringEnum = void 0;
const typebox_1 = require("@sinclair/typebox");
const StringEnum = (vals, options) => typebox_1.Type.Unsafe({ ...options, enum: vals });
exports.StringEnum = StringEnum;
